import "../../styles/bootstrap/bootstrap-popover.scss";
import "../../styles/popoverOverride.scss";
import "./formList.scss";

import PropTypes from "prop-types";
import React, { Fragment } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { PopoverBody } from "reactstrap";

import NavigationToolbar from "../../components/navigationToolbar";
import { withScreenContext } from "../../components/screen/ScreenContext";
import { isScreenModeMobile } from "../../constants/screenModes";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import Icon from "../interface/Icon";
import { popoverOrPortal } from "../portal/popoverOrPortal";
import FormButton from "./FormButton";
import FormDropdown from "./FormDropdown";

class FormDependencyListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resolvePopoverOpen: false
    };
    this.toggleResolvePopover = this.toggleResolvePopover.bind(this);
    this.renderResolvePopover = this.renderResolvePopover.bind(this);
    this.onChooseResolutionClick = this.onChooseResolutionClick.bind(this);
    this.onRemoveClick = this.onRemoveClick.bind(this);
  }

  toggleResolvePopover() {
    this.setState({
      resolvePopoverOpen: !this.state.resolvePopoverOpen
    });
  }

  onChooseResolutionClick(optionId) {
    this.props.onChooseResolution(optionId, this.props.value);
    this.toggleResolvePopover();
  }

  onRemoveClick() {
    this.props.onDeleteItem(this.props.value);
    this.toggleResolvePopover();
  }

  renderResolvePopover() {
    const { value, resolutionOptions } = this.props;

    let placement = "bottom-start";
    let hideArrow = false;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `inspectorPopover`,
      placement,
      hideArrow,
      isOpen: this.state.resolvePopoverOpen,
      target: `resolveDependency-${value}`,
      toggle: this.toggle,
      boundariesElement: "viewport"
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title={this.props.title}
            showBack={true}
            showBackArrow={true}
            onBackClick={this.toggleResolvePopover}
            backText={this.props.backText ? this.props.backText : "Back"}
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>
          <div>
            {resolutionOptions.map(o => {
              return (
                <div key={o.id} className="resolveConstraintOption">
                  <FormButton linkStyle onClick={() => this.onChooseResolutionClick(o.id)} label={o.label} />
                  <div className="inspectorConstraintContentTitle">{o.offset}</div>
                </div>
              );
            })}
            <div className="resolveConstraintOption">
              <FormButton linkStyle onClick={this.onRemoveClick} label="Remove dependency" />
            </div>
          </div>
        </PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  render() {
    const isIos = preprocessorQuery.isIos();
    const { label, value, leftIcon, leftIconColor, subValue, subOptions, isViolated } = this.props;
    return (
      <div key={value} className="formListItem">
        {leftIcon ? (
          <Icon className="formListLeftIcon" icon={leftIcon} color={leftIconColor ? leftIconColor : "iconMono"} />
        ) : null}
        <div className="formListItemContent">
          <span
            className={`formListItemLabel ${this.props.onItemClick ? "clickable" : ""}`}
            onClick={() => this.props.onItemClick(value)}
          >
            {label}
          </span>
          <FormDropdown
            value={subValue}
            options={subOptions}
            onChange={val => this.props.onSubValueChange(value, val)}
            arrowIcon={isIos ? "blank" : null}
          />
          {isViolated ? (
            <FormButton
              linkStyle
              onClick={this.toggleResolvePopover}
              label="Resolve"
              id={`resolveDependency-${value}`}
            />
          ) : null}
        </div>
        {this.props.canDelete ? (
          <Icon icon="listDelete" color="iconMono" onClick={() => this.props.onDeleteItem(value)} />
        ) : null}
        {this.state.resolvePopoverOpen ? (
          <div className="formListBackdrop" onClick={this.toggleResolvePopover} />
        ) : null}
        {this.state.resolvePopoverOpen ? this.renderResolvePopover() : null}
      </div>
    );
  }
}

FormDependencyListItem.propTypes = {
  label: PropTypes.string.isRequired,
  subValue: PropTypes.string.isRequired,
  subOptions: PropTypeShapes.listOptionArray.isRequired,
  leftIcon: PropTypes.string,
  leftIconColor: PropTypes.string,
  value: PropTypes.string.isRequired,
  isViolated: PropTypes.bool,
  title: PropTypes.string,
  backText: PropTypes.string,
  resolutionOptions: ImmutablePropTypes.list,
  onChooseResolution: PropTypes.func.isRequired,
  onSubValueChange: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
  canDelete: PropTypes.bool,

  //#!if iOS === true
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = FormDependencyListItem;
//#!if iOS === true
// exportedView = withScreenContext(FormDependencyListItem);
//#!endif
export default exportedView;
